// extracted by mini-css-extract-plugin
export default {"GroupDetails":"GroupDetail_GroupDetails__-macv","tableResponsive":"GroupDetail_tableResponsive__+U2s7","newbtn":"GroupDetail_newbtn__mkkwm"};